import { PDFDownloadLink } from "@react-pdf/renderer";
import React, { useEffect, useRef, useState } from "react";
import PDFReport from "../PDFReport/PDFReport";
import html2canvas from "html2canvas";
import {
  BarChart,
  Bar,
  XAxis,
  YAxis,
  Tooltip,
  ResponsiveContainer,
  PieChart,
  Pie,
  Cell,
  Legend,
} from "recharts";
const ReportSection = ({ reportData, showOnly }) => {
  const [chartImages, setChartImages] = useState({});
  const [imagesReady, setImagesReady] = useState(false);
  const [showChartMap, setShowChartMap] = useState({});
  const chartRefs = useRef({});

  const openChart = (title) =>
    setShowChartMap((prev) => ({ ...prev, [title]: true }));
  const closeChart = (title) =>
    setShowChartMap((prev) => ({ ...prev, [title]: false }));
  const COLORS = [
    "#8884d8",
    "#82ca9d",
    "#ffc658",
    "#ff8042",
    "#FF6347",
    "#4B0082",
    "#20B2AA",
    "#FFD700",
    "#7B68EE",
    "#FF1493",
    "#00CED1",
    "#32CD32",
  ];
  const mentorVerification = {
    title: "Mentor Verification",
    tableType: "gender",
    tableHeader: "Mentor Verification",
    metrics: [
      {
        label: "Mentor Verified Candidates",
        value: reportData?.demographics?.mentorVerified?.total || 0,
        male: reportData?.demographics?.mentorVerified?.male || 0,
        female: reportData?.demographics?.mentorVerified?.female || 0,
      },
    ],
  };

  const maritalStatusBreakdown = {
    title: "Marital Status Breakdown",
    tableType: "gender",
    tableHeader: "Marital Status",
    metrics: [
      {
        label: "Never Married",
        value: reportData?.demographics?.maritalStatus?.neverMarried?.total || 0,
        male: reportData?.demographics?.maritalStatus?.neverMarried?.male || 0,
        female: reportData?.demographics?.maritalStatus?.neverMarried?.female || 0,
      },
      {
        label: "Divorced",
        value: reportData?.demographics?.maritalStatus?.divorced?.total || 0,
        male: reportData?.demographics?.maritalStatus?.divorced?.male || 0,
        female: reportData?.demographics?.maritalStatus?.divorced?.female || 0,
      },
      {
        label: "Widow",
        value: reportData?.demographics?.maritalStatus?.widow?.total || 0,
        male: reportData?.demographics?.maritalStatus?.widow?.male || 0,
        female: reportData?.demographics?.maritalStatus?.widow?.female || 0,
      },
      {
        label: "Widower",
        value: reportData?.demographics?.maritalStatus?.widower?.total || 0,
        male: reportData?.demographics?.maritalStatus?.widower?.male || 0,
        female: reportData?.demographics?.maritalStatus?.widower?.female || 0,
      },
            {
        label: "Married",
        value: reportData?.demographics?.maritalStatus?.married?.total || 0,
        male: reportData?.demographics?.maritalStatus?.married?.male || 0,
        female: reportData?.demographics?.maritalStatus?.married?.female || 0,
      },
            {
        label: "Mrriage Fixed",
        value: reportData?.demographics?.maritalStatus?.marriageFixed?.total || 0,
        male: reportData?.demographics?.maritalStatus?.marriageFixed?.male || 0,
        female: reportData?.demographics?.maritalStatus?.marriageFixed?.female || 0,
      },
    ],
  };

  const ageWiseBreakdown = {
    title: "Age-wise Breakdown",
    tableType: "gender",
    tableHeader: "Age Group",
    metrics: [
            {
        label: "18 to 20",
        value: reportData?.demographics?.ageGroups?.["Unknown"]?.total || 0,
        male: reportData?.demographics?.ageGroups?.["Unknown"]?.male || 0,
        female: reportData?.demographics?.ageGroups?.["Unknown"]?.female || 0,
      },
      {
        label: "20 to 30",
        value: reportData?.demographics?.ageGroups?.["20-30"]?.total || 0,
        male: reportData?.demographics?.ageGroups?.["20-30"]?.male || 0,
        female: reportData?.demographics?.ageGroups?.["20-30"]?.female || 0,
      },
      {
        label: "30 to 40",
        value: reportData?.demographics?.ageGroups?.["30-40"]?.total || 0,
        male: reportData?.demographics?.ageGroups?.["30-40"]?.male || 0,
        female: reportData?.demographics?.ageGroups?.["30-40"]?.female || 0,
      },
      {
        label: "40 to 50",
        value: reportData?.demographics?.ageGroups?.["40-50"]?.total || 0,
        male: reportData?.demographics?.ageGroups?.["40-50"]?.male || 0,
        female: reportData?.demographics?.ageGroups?.["40-50"]?.female || 0,
      },
      {
        label: "50 and above",
        value: reportData?.demographics?.ageGroups?.["50+"]?.total || 0,
        male: reportData?.demographics?.ageGroups?.["50+"]?.male || 0,
        female: reportData?.demographics?.ageGroups?.["50+"]?.female || 0,
      },

    ],
  };

  // "Age-wise Registered vs Active" -> renamed data to Register / Signup / Active per age group
  const ageWiseRegisteredActive = {
    title: "Age-wise Register and Signup and Active",
    tableType: "regSignupActive",
    tableHeader: "Age Group",
    metrics: [
            {
        label: "18 to 20",
        value:
          (reportData?.demographics?.ageGroups?.["Unknown"]?.registered || 0) +
          (reportData?.demographics?.ageGroups?.["Unknown"]?.signup || 0) +
          (reportData?.demographics?.ageGroups?.["Unknown"]?.active || 0),
        register: reportData?.demographics?.ageGroups?.["Unknown"]?.registered || 0,
        signup: reportData?.demographics?.ageGroups?.["Unknown"]?.signup || 0,
        active: reportData?.demographics?.ageGroups?.["Unknown"]?.active || 0,
      },
      {
        label: "20 to 30",
        value:
          (reportData?.demographics?.ageGroups?.["20-30"]?.registered || 0) +
          (reportData?.demographics?.ageGroups?.["20-30"]?.signup || 0) +
          (reportData?.demographics?.ageGroups?.["20-30"]?.active || 0),
        register: reportData?.demographics?.ageGroups?.["20-30"]?.registered || 0,
        signup: reportData?.demographics?.ageGroups?.["20-30"]?.signup || 0,
        active: reportData?.demographics?.ageGroups?.["20-30"]?.active || 0,
      },
      {
        label: "30 to 40",
        value:
          (reportData?.demographics?.ageGroups?.["30-40"]?.registered || 0) +
          (reportData?.demographics?.ageGroups?.["30-40"]?.signup || 0) +
          (reportData?.demographics?.ageGroups?.["30-40"]?.active || 0),
        register: reportData?.demographics?.ageGroups?.["30-40"]?.registered || 0,
        signup: reportData?.demographics?.ageGroups?.["30-40"]?.signup || 0,
        active: reportData?.demographics?.ageGroups?.["30-40"]?.active || 0,
      },
      {
        label: "40 to 50",
        value:
          (reportData?.demographics?.ageGroups?.["40-50"]?.registered || 0) +
          (reportData?.demographics?.ageGroups?.["40-50"]?.signup || 0) +
          (reportData?.demographics?.ageGroups?.["40-50"]?.active || 0),
        register: reportData?.demographics?.ageGroups?.["40-50"]?.registered || 0,
        signup: reportData?.demographics?.ageGroups?.["40-50"]?.signup || 0,
        active: reportData?.demographics?.ageGroups?.["40-50"]?.active || 0,
      },
      {
        label: "50 and above",
        value:
          (reportData?.demographics?.ageGroups?.["50+"]?.registered || 0) +
          (reportData?.demographics?.ageGroups?.["50+"]?.signup || 0) +
          (reportData?.demographics?.ageGroups?.["50+"]?.active || 0),
        register: reportData?.demographics?.ageGroups?.["50+"]?.registered || 0,
        signup: reportData?.demographics?.ageGroups?.["50+"]?.signup || 0,
        active: reportData?.demographics?.ageGroups?.["50+"]?.active || 0,
      },
    ],
  };
  // --- Data Sections ---
  const userMetrics = {
    title: "User Metrics",
    tableType: "gender",
    tableHeader: "Metrics",

    metrics: [
      {
        label: "Total Candidates",
        value: reportData?.totalUsers?.allUsers || 0,
        male: reportData?.totalUsers?.male || 0,
        female: reportData?.totalUsers?.female || 0,
      },
      {
        label: "Active Users",
        value: reportData?.totalUsers?.activeUsers || 0,
        male: reportData?.totalUsers?.activeMaleUsers || 0,
        female: reportData?.totalUsers?.activeFemaleUsers || 0,
      },
      {
        label: "New Registrations",
        value: reportData?.totalUsers?.registerUsers || 0,
        male: reportData?.totalUsers?.registerMale || 0,
        female: reportData?.totalUsers?.registerFemale || 0,
      },
      {
        label: "Signup Users",
        value: reportData?.totalUsers?.signupUsers || 0,
        male: reportData?.totalUsers?.signupMale || 0,
        female: reportData?.totalUsers?.signupFemale || 0,
      },
    ],
  };
    
    const userRequest = {
      title: "Users Requests Summary",
      tableType: "adminUser",
      tableHeader: "Users Requests",

      metrics: [
        {
          label: "Total Requests",
          value: reportData?.requestRecord?.total || 0,
          admin: "-",
          user: reportData?.requestRecord?.total || 0,
        },
        {
          label: "Pending Requests",
          value: (reportData?.requestRecord?.pending || 0)+(reportData?.requestRecord?.acceptedUserPending || 0),
          admin: reportData?.requestRecord?.pending || 0,
          user: reportData?.requestRecord?.acceptedUserPending || 0,
        },
        {
          label: "Accepted Requests",
          value:
            (reportData?.requestRecord?.adminAccepted || 0) +
            (reportData?.requestRecord?.acceptedUserAccepted || 0),
          admin: reportData?.requestRecord?.adminAccepted || 0,
          user:
            reportData?.requestRecord?.acceptedUserAccepted || 0,
        },
        {
          label: "Declined Requests",
          value:
            (reportData?.requestRecord?.adminRejected || 0) +
            (reportData?.requestRecord?.acceptedUserRejected || 0),
          admin: reportData?.requestRecord?.adminRejected || 0,
          user:
            reportData?.requestRecord?.acceptedUserRejected || 0,
        },
      ],
    };


    const adminSuggestions = {
      title: "Admin Suggestions",
      tableHeader: "Admin Suggestions",

      metrics: [
        {
          label: "Total Suggestions Made by Admins",
          value: reportData?.matchesRecord?.total || 0,
          date: new Date().toISOString(),
        },
        {
          label: "Accepted by Users",
          value: reportData?.matchesRecord?.accepted || 0,
          date: new Date().toISOString(),
        },
        {
          label: "Declined by Users",
          value: reportData?.matchesRecord?.rejected || 0,
          date: new Date().toISOString(),
        },
        {
          label: "Pending User Responses",
          value: reportData?.matchesRecord?.pending || 0,
          date: new Date().toISOString(),
        },
      ],
    };

    const questionaireRequest = {
      title: "Questionnaire Requests Summary",
      tableType: "adminUser",
      tableHeader: "Questionnaire Requests",
      metrics: [
        {
          label: "Total Questionnaire Requests",
          value: reportData?.questionaireRequest?.total || 0,
          admin: "-",
          user: reportData?.questionaireRequest?.total || 0,
        },
        {
          label: "Pending Requests",
          value:
            (reportData?.questionaireRequest?.pending || 0) +
            (reportData?.questionaireRequest?.acceptedUserPending ||
              0),
          admin: reportData?.questionaireRequest?.pending || 0,
          user:
            reportData?.questionaireRequest?.acceptedUserPending ||
            0,
        },
        {
          label: "Accepted Requests",
          value:
            (reportData?.questionaireRequest?.adminAccepted || 0) +
            (reportData?.questionaireRequest
              ?.acceptedUserAccepted || 0),
          admin:
            reportData?.questionaireRequest?.adminAccepted || 0,
          user:
            reportData?.questionaireRequest?.acceptedUserAccepted ||
            0,
        },
        {
          label: "Declined Requests",
          value:
            (reportData?.questionaireRequest?.adminRejected || 0) +
            (reportData?.questionaireRequest
              ?.acceptedUserRejected || 0),
          admin:
            reportData?.questionaireRequest?.adminRejected || 0,
          user:
            reportData?.questionaireRequest?.acceptedUserRejected ||
            0,
        },
        {
          label: "Mutually Accepted",
          value:
            reportData?.questionaireRequest?.mutuallyAccpted || 0,
          admin: "-",
          user:
            reportData?.questionaireRequest?.mutuallyAccpted || 0,
        },
      ],
    };


    const rejectedReasons = {
      title: "Declined Reasons Summary",
      tableType: "totalOnly",
      tableHeader: "Declined Reasons",

      metrics: [
        {
          label: "Horoscope doesn't match",
          value: reportData?.rejectReason?.[0]?.count || 0,
          date: new Date().toISOString(),
        },
        {
          label: "Age difference not suitable",
          value: reportData?.rejectReason?.[1]?.count || 0,
          date: new Date().toISOString(),
        },
        {
          label: "Location not suitable",
          value: reportData?.rejectReason?.[2]?.count || 0,
          date: new Date().toISOString(),
        },
        {
          label: "Caste not suitable",
          value: reportData?.rejectReason?.[3]?.count || 0,
          date: new Date().toISOString(),
        },
        {
          label: "Mother tongue not suitable",
          value: reportData?.rejectReason?.[4]?.count || 0,
          date: new Date().toISOString(),
        },
        {
          label: "Income not suitable",
          value: reportData?.rejectReason?.[5]?.count || 0,
          date: new Date().toISOString(),
        },
        {
          label: "Profession not suitable",
          value: reportData?.rejectReason?.[6]?.count || 0,
          date: new Date().toISOString(),
        },
        {
          label: "Height difference not suitable",
          value: reportData?.rejectReason?.[7]?.count || 0,
          date: new Date().toISOString(),
        },
        {
          label: "Spiritual status not as required",
          value: reportData?.rejectReason?.[8]?.count || 0,
          date: new Date().toISOString(),
        },
         {
          label: "Martial status not as expected",
          value: reportData?.rejectReason?.[9]?.count || 0,
          date: new Date().toISOString(),
        },
         {
          label: "No response from the either side",
          value: reportData?.rejectReason?.[10]?.count || 0,
          date: new Date().toISOString(),
        },
         {
          label: "No response from boy",
          value: reportData?.rejectReason?.[11]?.count || 0,
          date: new Date().toISOString(),
        },
         {
          label: "No response from girl",
          value: reportData?.rejectReason?.[12]?.count || 0,
          date: new Date().toISOString(),
        },
         {
          label: "Expectations are not matching",
          value: reportData?.rejectReason?.[13]?.count || 0,
          date: new Date().toISOString(),
        },
         {
          label: "Candidate requested Admin to Decline",
          value:  reportData?.rejectReason?.[14]?.count || 0,
          date: new Date().toISOString(),
        },
        // {
        //   label: "Fill the proper answer in questionnaire",
        //   value: reportData?.reportData?.rejectReason?.[9]?.count || 0,
        //   date: new Date().toISOString(),
        // },
      ],
    };

    const totalNotesCount = reportData?.notes?.totalNotes || 0;

    const notesMade = {
      title: "Admin Notes Made",
      tableType: "totalOnly",
      tableHeader:"Admin Notes Made",

      metrics: [
        {
          label: "Total Notes",
          value: totalNotesCount,
          date: new Date().toISOString(),
        },
        ...(Array.isArray(reportData?.notes?.notes)
          ? reportData?.notes?.notes.map((note, index) => ({
              label: note?.name || `Admin ${index + 1}`,
              value: note?.count || 0,
              date: new Date().toISOString(),
            }))
          : []),
      ],
    };

    const reportSections = [
      userMetrics,
      mentorVerification,
      maritalStatusBreakdown,
      ageWiseBreakdown,
      ageWiseRegisteredActive,
      userRequest,
      adminSuggestions,
      questionaireRequest,
      rejectedReasons,
      notesMade,
    ];

const filteredReportSections = showOnly
  ? reportSections.filter((section) => showOnly.includes(section.title))
  : reportSections;

  // --- HTML2Canvas Capture Effect ---
  useEffect(() => {
    setImagesReady(false);
    const captureAllCharts = async () => {
      const images = {};
      for (let section of reportSections) {
        const node = chartRefs.current[section.title];
        if (node) {
          const canvas = await html2canvas(node, {
            scale: 2,
            useCORS: true,
            backgroundColor: "#ffffff",
          });
          images[section.title] = canvas.toDataURL("image/png");
        }
      }
      setChartImages(images);
      setImagesReady(true);
    };
    const timeout = setTimeout(captureAllCharts, 2000); // 2s to ensure render
    return () => clearTimeout(timeout);
  }, [JSON.stringify(reportData)]);

  return (
    <>
      <div className="borderRaduis-20 space-y-4 bg-white p-4">
        {filteredReportSections.map((section, idx) => (
          <div key={idx} className="border-b pb-10">
            <div className="mb-4 flex items-center justify-between">
              <h2 className="ml-10 text-xl font-bold text-gray-800">
                {section.title}
              </h2>
              <button
                onClick={() =>
                  showChartMap[section.title]
                    ? closeChart(section.title)
                    : openChart(section.title)
                }
                className={`rounded px-4 py-2 text-sm text-white ${showChartMap[section.title] ? "bg-red-500 hover:bg-red-600" : "bg-green-500 hover:bg-green-600"}`}
              >
                {showChartMap[section.title] ? "Close Chart" : "Show Chart"}
              </button>
            </div>

            <div className="mt-4 flex flex-col gap-6 md:flex-row">
              {/* Table Section */}
              <div
                className={`space-y-4 ${showChartMap[section.title] ? "md:w-1/2" : "w-full"}`}
              >
                <table className="w-full table-auto border border-gray-300 text-sm">
                  <thead className="bg-gray-100">
                    <tr>
                      <th className="border px-3 py-2 text-left">
                        {section.tableHeader}
                      </th>
                      <th className="border px-3 py-2 text-center">Total</th>
                      {section.tableType === "gender" && (
                        <>
                          <th className="border px-3 py-2 text-center">Male</th>
                          <th className="border px-3 py-2 text-center">
                            Female
                          </th>
                        </>
                      )}
                      {section.tableType === "adminUser" && (
                        <>
                          <th className="border px-3 py-2 text-center">
                            Admin
                          </th>
                          <th className="border px-3 py-2 text-center">User</th>
                        </>
                      )}
                      {section.tableType === "regSignupActive" && (
                        <>
                          <th className="border px-3 py-2 text-center">
                            Register User
                          </th>
                          <th className="border px-3 py-2 text-center">
                            Signup User
                          </th>
                          <th className="border px-3 py-2 text-center">
                            Active User
                          </th>
                        </>
                      )}
                    </tr>
                  </thead>
                  <tbody>
                    {section.metrics.map((metric, index) => (
                      <tr key={index} className="hover:bg-gray-50">
                        <td className="border px-3 py-2">{metric.label}</td>
                        <td className="border px-3 py-2 text-center">
                          {metric.value}
                        </td>
                        {section.tableType === "gender" && (
                          <>
                            <td className="border px-3 py-2 text-center">
                              {metric.male}
                            </td>
                            <td className="border px-3 py-2 text-center">
                              {metric.female}
                            </td>
                          </>
                        )}
                        {section.tableType === "adminUser" && (
                          <>
                            <td className="border px-3 py-2 text-center">
                              {metric.admin}
                            </td>
                            <td className="border px-3 py-2 text-center">
                              {metric.user}
                            </td>
                          </>
                        )}
                        {section.tableType === "regSignupActive" && (
                          <>
                            <td className="border px-3 py-2 text-center">
                              {metric.register}
                            </td>
                            <td className="border px-3 py-2 text-center">
                              {metric.signup}
                            </td>
                            <td className="border px-3 py-2 text-center">
                              {metric.active}
                            </td>
                          </>
                        )}
                      </tr>
                    ))}
                  </tbody>
                </table>
              </div>

              {/* Chart Section (Visible UI) */}
{showChartMap[section.title] && (
  <div className="h-[350px] w-full md:w-1/2">
    {section.metrics.length <= 4 ? (
      <ResponsiveContainer width="100%" height="100%">
        <PieChart>
          <Pie
            data={section.metrics}
            dataKey="value"
            nameKey="label"
            cx="50%"
            cy="50%"
            outerRadius={80}
            label
          >
            {section.metrics.map((_, index) => (
              <Cell
                key={`cell-${index}`}
                fill={COLORS[index % COLORS.length]}
              />
            ))}
          </Pie>
          <Tooltip />
          <Legend />
        </PieChart>
      </ResponsiveContainer>
    ) : (
      <ResponsiveContainer width="100%" height="100%">
        <BarChart
          data={[
            section.metrics.reduce(
              (obj, item) => ({ ...obj, [item.label]: item.value }),
              {},
            ),
          ]}
          style={{ padding: 30 }}
        >
          <XAxis hide />
          <YAxis />
          <Tooltip
            shared={false}
            cursor={{ fill: "transparent" }}
            formatter={(value, name) => value === 0 ? null : [value, name]}
          />
          <Legend verticalAlign="bottom" height={36} />
          {section.metrics.map((entry, i) => (
            <Bar
              key={i}
              isAnimationActive={false}
              dataKey={entry.label}
              fill={COLORS[i % COLORS.length]}
              name={entry.label}
            />
          ))}
        </BarChart>
      </ResponsiveContainer>
    )}
  </div>
)}
            </div>

            {/* Individual Section Download */}
            <div className="mt-4 flex justify-center py-7">
              <PDFDownloadLink
                document={
                  <PDFReport
                    reportSections={[section]}
                    chartImages={chartImages}
                  />
                }
                fileName={`${section.title.toLowerCase().replace(/\s+/g, "_")}.pdf`}
                className={`rounded px-4 py-2 text-white ${!imagesReady ? "bg-gray-400" : "bg-yellow-500"}`}
              >
                {({ loading }) =>
                  loading || !imagesReady ? "Processing..." : "Download"
                }
              </PDFDownloadLink>
            </div>
          </div>
        ))}

        {/* Overall Download */}
        <div className="flex justify-center pt-10">
          <PDFDownloadLink
            document={
              <PDFReport
                reportSections={filteredReportSections}
                chartImages={chartImages}
              />
            }
            fileName="overall_report.pdf"
            className={`rounded px-6 py-3 font-bold text-white ${!imagesReady ? "bg-gray-400" : "bg-yellow-600"}`}
          >
            {({ loading }) =>
              loading || !imagesReady
                ? "Preparing Full Report..."
                : " Overall Download "
            }
          </PDFDownloadLink>
        </div>

        {/* --- HIDDEN CAPTURE AREA (Fixes the color issue) --- */}
        <div style={{ position: "absolute", left: "-9999px", top: 0 }}>
          {reportSections.map((section) => (
            <div
              key={`capture-${section.title}`}
              ref={(el) => (chartRefs.current[section.title] = el)}
              style={{ width: "800px", padding: "40px", background: "white" }}
            >
              <h2
                style={{
                  textAlign: "center",
                  fontSize: "24px",
                  marginBottom: "20px",
                }}
              >
                {section.title}
              </h2>
              <div style={{ height: "400px" }}>
                <ResponsiveContainer width="100%" height="100%">
                  {section.metrics.length <= 4 ? (
                    <PieChart>
                      <Pie
                        isAnimationActive={false} // Crucial for static capture
                        data={section.metrics}
                        dataKey="value"
                        nameKey="label"
                        outerRadius={120}
                        label
                      >
                        {section.metrics.map((_, index) => (
                          <Cell
                            key={`cap-cell-${index}`}
                            fill={COLORS[index % COLORS.length]}
                          />
                        ))}
                      </Pie>
                      <Legend />
                    </PieChart>
                  ) : (
                    <BarChart
                      data={[
                        section.metrics.reduce(
                          (obj, item) => ({ ...obj, [item.label]: item.value }),
                          {},
                        ),
                      ]}
                    >
                      <XAxis hide />
                      <YAxis />
                      <Legend verticalAlign="bottom" height={36} />
                      {section.metrics.map((entry, i) => (
                        <Bar
                          key={i}
                          isAnimationActive={false}
                          dataKey={entry.label}
                          fill={COLORS[i % COLORS.length]}
                          name={entry.label}
                        />
                      ))}
                    </BarChart>
                  )}
                </ResponsiveContainer>
              </div>
            </div>
          ))}
        </div>
      </div>
    </>
  );
};

export default ReportSection;